import { render, staticRenderFns } from "./datatable-family.component.vue?vue&type=template&id=e58d972e"
import script from "./datatable-family.component.vue?vue&type=script&lang=ts"
export * from "./datatable-family.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports